import { cx } from "./cva.ts"

export const BlinkingCursor = ({
  children,
  className,
}: {
  children?: React.ReactNode
  className?: string
}) => <span className={cx("animate-blink", className)}>{children ?? "▍"}</span>
